import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  ViewController,
} from "ionic-angular";
import { FannelDetailPage } from "../fannel-detail/fannel-detail";
import { WalletService } from "../../services/wallet.service";
import { FannelApplicantsPage } from "../fannel-applicants/fannel-applicants";
import { FannelInfoPage } from "../fannel-info/fannel-info";
import { WalletPage } from "../wallet/wallet";
import { ConfigService } from "../../services/config.service";
import { Store } from "@ngrx/store";
import { AppUtilities } from "../../app/app.utilities";
import * as firebase from "firebase";
import { User } from "../../app/app.models";
import { AppState } from "../../app/app.reducer";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "page-fannel",
  templateUrl: "fannel.html",
})
export class FannelPage {
  fannels: any[] = [];
  idol: any;
  user$: User;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private walletService: WalletService,
    private utilities: AppUtilities,
    public modalCtrl: ModalController,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    public store: Store<AppState>,
    private authService: AuthService
  ) {
    this.idol = this.navParams.get("idol");
    this.utilities.loading();
    this.user$ = this.authService.getUser();
    this.getFannelAppliants();
    this.utilities.loadingDismiss();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad FannelPage");
  }

  ionViewWillEnter() {}

  goInfo() {
    const modal = this.modalCtrl.create(FannelInfoPage);
    modal.present();
  }

  goDetailFannel(fannel) {
    if (fannel.open && !fannel.applied) {
      let profileModal = this.modalCtrl.create(FannelDetailPage, {
        fannel: fannel,
        idol: this.idol,
      });
      profileModal.onDidDismiss((data) => {
        console.log(data);
        if (data === "applicants") {
          this.fannels = [];
          this.getFannelAppliants();
        }
        if (data === "wallet") {
          this.navCtrl.push(WalletPage, { segment: "address" });
        }
      });
      profileModal.present();
      //this.navCtrl.push(FannelDetailPage, { fannel: fannel, idol: this.idol });
    }
    if (fannel.open && fannel.applied) {
      var idiom = this.configService.getIdiom();
      if (idiom == "en")
        this.utilities.alert("You have already applied to the fannel.");

      if (idiom == "es") this.utilities.alert("Ya has aplicado al fannel.");
    }

    if (!fannel.open) {
      this.navCtrl.push(FannelApplicantsPage, { fannel: fannel });
    }
  }

  fannelApplied(fannel) {
    var num = 1;
    while (fannel["applicants" + num]) {
      if (
        fannel["applicants" + num].address == this.walletService.getAddress() ||
        fannel["applicants" + num].uid == this.user$.uid
      ) {
        console.log("Fannel Applicants " + fannel["applicants" + num].name);
        console.log(
          "Fannel Applicants true" + fannel["applicants" + num].address
        );
        fannel.applied = true;
      }
      fannel.numApplicants = num;
      num++;
    }

    return fannel;
  }

  /* getFannelAppliants1() {
    //production
    var database = firebase.database().ref("prod_fannels/" + this.idol.address);
    //test
    //var database = firebase.database().ref('fannels/' + this.idol.address);
    database.on("child_added", snapshot => {
      var fannel = snapshot.val();
      var n = Date.now();
      if (fannel.periode > n) {
        fannel.open = true;
        var sg = (fannel.periode - n) / 1000;
        //var min = sg / 60;
        //console.log('minutos restatnes ' + min);
        //fannel.min = parseInt(min.toString(), 10);
        fannel.time = this.transformSeconds(sg);
        console.log("Horas minutos y segundos Refresh", fannel.time);
      } else {
        fannel.open = false;
      }
      console.log(
        "Título fannel " + fannel.title + "fannel Units" + fannel.units
      );
      fannel = this.fannelApplied(fannel);
      this.fannels.push(fannel);
      this.fannels.sort((a, b) => {
        return b.periode - a.periode;
      });
    });
  }*/

  getFannelAppliants() {
    //production
    var database = firebase.database().ref("prod_fannels/" + this.idol.address);
    //test
    //var database = firebase.database().ref('fannels/' + this.idol.address);
    //&database.on("child_added", snapshot => {
    database.once("value").then((snapshot) => {
      if (snapshot.val()) {
        var fannels = snapshot.val();
        var keys = Object.keys(fannels);
        keys.forEach((key) => {
          var fannel = fannels[key];
          var n = Date.now();
          if (fannel.periode > n) {
            fannel.open = true;
            var sg = (fannel.periode - n) / 1000;
            //var min = sg / 60;
            //console.log('minutos restatnes ' + min);
            //fannel.min = parseInt(min.toString(), 10);
            fannel.time = this.transformSeconds(sg);
            console.log("Horas minutos y segundos Refresh", fannel.time);
          } else {
            fannel.open = false;
          }
          console.log(
            "Título fannel " + fannel.title + "fannel Units" + fannel.units
          );
          fannel = this.fannelApplied(fannel);
          this.fannels.push(fannel);
          this.fannels.sort((a, b) => {
            return b.periode - a.periode;
          });
        });
      }
    });
  }

  doRefresh($event) {
    this.fannels = [];
    //production
    var database = firebase.database().ref("prod_fannels/" + this.idol.address);
    //test
    //var database = firebase.database().ref('fannels/' + this.idol.address);
    //database.on("child_added", snapshot => {
    database.once("value").then((snapshot) => {
      var fannels = snapshot.val();
      var keys = Object.keys(fannels);
      keys.forEach((key) => {
        var fannel = fannels[key];
        var n = Date.now();
        if (fannel.periode > n) {
          fannel.open = true;
          var sg = (fannel.periode - n) / 1000;
          //var min = sg / 60;
          //console.log('minutos restatnes ' + min);
          //fannel.min = parseInt(min.toString(), 10);
          fannel.time = this.transformSeconds(sg);
          console.log("Horas minutos y segundos Refresh", fannel.time);
        } else {
          fannel.open = false;
        }
        console.log(
          "Título fannel " + fannel.title + "fannel Units" + fannel.units
        );
        fannel = this.fannelApplied(fannel);
        this.fannels.push(fannel);
        this.fannels.sort((a, b) => {
          return b.periode - a.periode;
        });
      });
    });
    $event.complete();
  }

  transformSeconds(timeSeconds: number) {
    var hours = Math.floor(timeSeconds / 3600);
    var m = Math.floor((timeSeconds % 3600) / 60);
    var minutos = m.toString();
    var s = timeSeconds % 60;
    var seconds = s.toString()[0] + s.toString()[1];
    s = parseInt(seconds);

    //Anteponiendo un 0 a los minutos si son menos de 10
    minutos = m < 10 ? "0" + minutos : minutos;

    //Anteponiendo un 0 a los segundos si son menos de 10
    seconds = s < 10 ? "0" + seconds : seconds;

    var result = hours + ":" + minutos + ":" + seconds; // 2:41:30
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/pages/fannel/fannel.ts